/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {BatchPatchFishGroup} from '../bioplanModels';
// @ts-ignore
import type {FishGroup} from '../bioplanModels';
// @ts-ignore
import type {FishGroupDefaultCV} from '../bioplanModels';
// @ts-ignore
import type {PatchFishGroup} from '../bioplanModels';
/**
 * PlanningFishGroupApi - axios parameter creator
 * @export
 */
export const PlanningFishGroupApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get fish group default CV by Id
     * @param {string} fishGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsFishGroupIdDefaultCVGet: async (
      fishGroupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishGroupId' is not null or undefined
      assertParamExists('fishGroupsFishGroupIdDefaultCVGet', 'fishGroupId', fishGroupId);
      const localVarPath = `/fishGroups/{fishGroupId}/defaultCV`.replace(
        `{${'fishGroupId'}}`,
        encodeURIComponent(String(fishGroupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get fish group by Id
     * @param {string} fishGroupId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsFishGroupIdGet: async (
      fishGroupId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishGroupId' is not null or undefined
      assertParamExists('fishGroupsFishGroupIdGet', 'fishGroupId', fishGroupId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('fishGroupsFishGroupIdGet', 'planId', planId);
      const localVarPath = `/fishGroups/{fishGroupId}`.replace(
        `{${'fishGroupId'}}`,
        encodeURIComponent(String(fishGroupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update fishGroup
     * @param {string} fishGroupId
     * @param {PatchFishGroup} patchFishGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsFishGroupIdPatch: async (
      fishGroupId: string,
      patchFishGroup: PatchFishGroup,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishGroupId' is not null or undefined
      assertParamExists('fishGroupsFishGroupIdPatch', 'fishGroupId', fishGroupId);
      // verify required parameter 'patchFishGroup' is not null or undefined
      assertParamExists('fishGroupsFishGroupIdPatch', 'patchFishGroup', patchFishGroup);
      const localVarPath = `/fishGroups/{fishGroupId}`.replace(
        `{${'fishGroupId'}}`,
        encodeURIComponent(String(fishGroupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(patchFishGroup, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all fish groups in the filter
     * @param {string} planId
     * @param {Array<string>} [fishGroupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsGet: async (
      planId: string,
      fishGroupId?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('fishGroupsGet', 'planId', planId);
      const localVarPath = `/fishGroups/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (fishGroupId) {
        localVarQueryParameter['fishGroupId'] = fishGroupId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update fishGroup
     * @param {BatchPatchFishGroup} batchPatchFishGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsPatch: async (
      batchPatchFishGroup: BatchPatchFishGroup,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'batchPatchFishGroup' is not null or undefined
      assertParamExists('fishGroupsPatch', 'batchPatchFishGroup', batchPatchFishGroup);
      const localVarPath = `/fishGroups/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(batchPatchFishGroup, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningFishGroupApi - functional programming interface
 * @export
 */
export const PlanningFishGroupApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningFishGroupApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get fish group default CV by Id
     * @param {string} fishGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupsFishGroupIdDefaultCVGet(
      fishGroupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishGroupDefaultCV>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupsFishGroupIdDefaultCVGet(fishGroupId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupApi.fishGroupsFishGroupIdDefaultCVGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get fish group by Id
     * @param {string} fishGroupId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupsFishGroupIdGet(
      fishGroupId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupsFishGroupIdGet(fishGroupId, planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupApi.fishGroupsFishGroupIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update fishGroup
     * @param {string} fishGroupId
     * @param {PatchFishGroup} patchFishGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupsFishGroupIdPatch(
      fishGroupId: string,
      patchFishGroup: PatchFishGroup,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupsFishGroupIdPatch(
        fishGroupId,
        patchFishGroup,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupApi.fishGroupsFishGroupIdPatch']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all fish groups in the filter
     * @param {string} planId
     * @param {Array<string>} [fishGroupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupsGet(
      planId: string,
      fishGroupId?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FishGroup>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupsGet(planId, fishGroupId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupApi.fishGroupsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update fishGroup
     * @param {BatchPatchFishGroup} batchPatchFishGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupsPatch(
      batchPatchFishGroup: BatchPatchFishGroup,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FishGroup>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupsPatch(batchPatchFishGroup, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupApi.fishGroupsPatch']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningFishGroupApi - factory interface
 * @export
 */
export const PlanningFishGroupApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningFishGroupApiFp(configuration);
  return {
    /**
     *
     * @summary Get fish group default CV by Id
     * @param {PlanningFishGroupApiFishGroupsFishGroupIdDefaultCVGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsFishGroupIdDefaultCVGet(
      requestParameters: PlanningFishGroupApiFishGroupsFishGroupIdDefaultCVGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishGroupDefaultCV> {
      return localVarFp
        .fishGroupsFishGroupIdDefaultCVGet(requestParameters.fishGroupId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get fish group by Id
     * @param {PlanningFishGroupApiFishGroupsFishGroupIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsFishGroupIdGet(
      requestParameters: PlanningFishGroupApiFishGroupsFishGroupIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishGroup> {
      return localVarFp
        .fishGroupsFishGroupIdGet(requestParameters.fishGroupId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update fishGroup
     * @param {PlanningFishGroupApiFishGroupsFishGroupIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsFishGroupIdPatch(
      requestParameters: PlanningFishGroupApiFishGroupsFishGroupIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishGroup> {
      return localVarFp
        .fishGroupsFishGroupIdPatch(requestParameters.fishGroupId, requestParameters.patchFishGroup, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all fish groups in the filter
     * @param {PlanningFishGroupApiFishGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsGet(
      requestParameters: PlanningFishGroupApiFishGroupsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<FishGroup>> {
      return localVarFp
        .fishGroupsGet(requestParameters.planId, requestParameters.fishGroupId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update fishGroup
     * @param {PlanningFishGroupApiFishGroupsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupsPatch(
      requestParameters: PlanningFishGroupApiFishGroupsPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<FishGroup>> {
      return localVarFp
        .fishGroupsPatch(requestParameters.batchPatchFishGroup, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for fishGroupsFishGroupIdDefaultCVGet operation in PlanningFishGroupApi.
 * @export
 * @interface PlanningFishGroupApiFishGroupsFishGroupIdDefaultCVGetRequest
 */
export interface PlanningFishGroupApiFishGroupsFishGroupIdDefaultCVGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupApiFishGroupsFishGroupIdDefaultCVGet
   */
  readonly fishGroupId: string;
}

/**
 * Request parameters for fishGroupsFishGroupIdGet operation in PlanningFishGroupApi.
 * @export
 * @interface PlanningFishGroupApiFishGroupsFishGroupIdGetRequest
 */
export interface PlanningFishGroupApiFishGroupsFishGroupIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupApiFishGroupsFishGroupIdGet
   */
  readonly fishGroupId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupApiFishGroupsFishGroupIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for fishGroupsFishGroupIdPatch operation in PlanningFishGroupApi.
 * @export
 * @interface PlanningFishGroupApiFishGroupsFishGroupIdPatchRequest
 */
export interface PlanningFishGroupApiFishGroupsFishGroupIdPatchRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupApiFishGroupsFishGroupIdPatch
   */
  readonly fishGroupId: string;

  /**
   *
   * @type {PatchFishGroup}
   * @memberof PlanningFishGroupApiFishGroupsFishGroupIdPatch
   */
  readonly patchFishGroup: PatchFishGroup;
}

/**
 * Request parameters for fishGroupsGet operation in PlanningFishGroupApi.
 * @export
 * @interface PlanningFishGroupApiFishGroupsGetRequest
 */
export interface PlanningFishGroupApiFishGroupsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupApiFishGroupsGet
   */
  readonly planId: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningFishGroupApiFishGroupsGet
   */
  readonly fishGroupId?: Array<string>;
}

/**
 * Request parameters for fishGroupsPatch operation in PlanningFishGroupApi.
 * @export
 * @interface PlanningFishGroupApiFishGroupsPatchRequest
 */
export interface PlanningFishGroupApiFishGroupsPatchRequest {
  /**
   *
   * @type {BatchPatchFishGroup}
   * @memberof PlanningFishGroupApiFishGroupsPatch
   */
  readonly batchPatchFishGroup: BatchPatchFishGroup;
}

/**
 * PlanningFishGroupApi - object-oriented interface
 * @export
 * @class PlanningFishGroupApi
 * @extends {BaseAPI}
 */
export class PlanningFishGroupApi extends BaseAPI {
  /**
   *
   * @summary Get fish group default CV by Id
   * @param {PlanningFishGroupApiFishGroupsFishGroupIdDefaultCVGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupApi
   */
  public fishGroupsFishGroupIdDefaultCVGet(
    requestParameters: PlanningFishGroupApiFishGroupsFishGroupIdDefaultCVGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupApiFp(this.configuration)
      .fishGroupsFishGroupIdDefaultCVGet(requestParameters.fishGroupId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get fish group by Id
   * @param {PlanningFishGroupApiFishGroupsFishGroupIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupApi
   */
  public fishGroupsFishGroupIdGet(
    requestParameters: PlanningFishGroupApiFishGroupsFishGroupIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupApiFp(this.configuration)
      .fishGroupsFishGroupIdGet(requestParameters.fishGroupId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update fishGroup
   * @param {PlanningFishGroupApiFishGroupsFishGroupIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupApi
   */
  public fishGroupsFishGroupIdPatch(
    requestParameters: PlanningFishGroupApiFishGroupsFishGroupIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupApiFp(this.configuration)
      .fishGroupsFishGroupIdPatch(requestParameters.fishGroupId, requestParameters.patchFishGroup, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all fish groups in the filter
   * @param {PlanningFishGroupApiFishGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupApi
   */
  public fishGroupsGet(requestParameters: PlanningFishGroupApiFishGroupsGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningFishGroupApiFp(this.configuration)
      .fishGroupsGet(requestParameters.planId, requestParameters.fishGroupId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update fishGroup
   * @param {PlanningFishGroupApiFishGroupsPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupApi
   */
  public fishGroupsPatch(
    requestParameters: PlanningFishGroupApiFishGroupsPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupApiFp(this.configuration)
      .fishGroupsPatch(requestParameters.batchPatchFishGroup, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
